const Footer = () => {
  return (
    <article className="footer">
      <a
        href="https://github.com/Rashidhussain547/"
        target="_blank"
        rel="noreferrer"
      >
        Designed & Rashid hussain &copy;2022
      </a>
    </article>
  );
};

export default Footer;
